import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { FlavorType } from 'src/app/products/interfaces/models';

import { SoftDrinkProperties } from '@app/api/models';
import { SubformBaseWithSugarContentPropertiesComponent } from '@products/components/forms/subform-base-with-sugar-content-properties/subform-base-with-sugar-content-properties.component';

@Component({
  selector: 'app-soft-drink-properties-subform',
  styleUrls: ['./soft-drink-properties-subform.component.scss'],
  templateUrl: './soft-drink-properties-subform.component.html',
})
export class SoftDrinkPropertiesSubformComponent extends SubformBaseWithSugarContentPropertiesComponent {
  override alcoholic = false;
  DICT_PATH = 'PRODUCTS.SOFT_DRINK_PROPERTIES';

  flavorType = FlavorType;

  static buildForm(fb: FormBuilder, data?: SoftDrinkProperties) {
    return fb.group({
      flavorTypes: [data?.flavorTypes, Validators.required],
      basedOnSoy: [data?.basedOnSoy ?? false],
      containsAtLeast50PercentMilkBasedMaterial: [
        data?.containsAtLeast50PercentMilkBasedMaterial ?? false,
      ],
      proteinContentIsOver28PercentByWeight: [
        data?.proteinContentIsOver28PercentByWeight ?? false,
      ],
      containsFruitsOrVegetablesAtLeast50Percent: [
        data?.containsFruitsOrVegetablesAtLeast50Percent ?? false,
      ],

      // build sugar content properties
      ...SubformBaseWithSugarContentPropertiesComponent.buildFields(data),
    });
  }

  onBasedOnSoyChanged(contains: boolean) {
    if (contains) {
      this.group.addControl(
        'proteinContentIsOver28PercentByWeight',
        this.fb.control(false)
      );
    } else {
      this.group.removeControl('proteinContentIsOver28PercentByWeight');
    }
  }
}
